! function() {
    "use strict";
    var e, t = {
            9138: function(e, t, s) {
                (0, s(2169).kz)(), new class {
                    constructor() {
                        this.initializeSwipers(), Shopify.designMode && document.addEventListener("shopify:section:load", () => this.initializeSwipers())
                    }
                    initializeSwipers() {
                        document.querySelectorAll("swiper-container").forEach(e => {
                            e.dataset.mobileSlidesPerView;
                            const t = (e.dataset.desktopSlidesPerView, "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView, "true" === e.dataset.textPagination),
                                s = Number(e.dataset.spaceBetweenMobile) || 16,
                                i = Number(e.dataset.spaceBetweenTablet) || 32,
                                r = Number(e.dataset.spaceBetweenDesktop) || 32,
                                a = e.dataset.mobileLayout || "slider",
                                n = e.dataset.desktopLayout || "slider",
                                o = window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
                                l = window.matchMedia("(min-width: 1024px)"),
                                d = () => {
                                    e.querySelectorAll("video").forEach(e => {
                                        e.classList.contains("section__wrapper-background") || e.pause()
                                    }), Array.from(e.querySelectorAll("swiper-slide")).filter(e => e.classList.contains("swiper-slide-visible")).forEach(e => {
                                        const t = e.querySelector("video");
                                        t && t.hasAttribute("autoplay") && t.play()
                                    })
                                },
                                c = () => {
                                    const t = e.closest(".slideshow-text-controls__wrapper");
                                    if (!t) return;
                                    const s = e.swiper.slides[e.swiper.realIndex];
                                    if (!s) return;
                                    const i = s.getAttribute("data-slide");
                                    t.querySelectorAll(".slideshow-text-controls__item").forEach(e => {
                                        e.classList.toggle("active", e.getAttribute("data-slide") === i)
                                    })
                                },
                                p = () => {
                                    if (l.matches && "slider" === n || o.matches && "slider" === a)
                                        if (!e.swiper || e.swiper.destroyed) {
                                            const a = parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                                                n = "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView ? parseFloat(e.dataset.tabletSlidesPerView) : a,
                                                o = parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                                                l = {
                                                    ...e.parentElement?.classList.contains("card__image") ? {
                                                        virtual: {
                                                            enabled: !0
                                                        },
                                                        nested: !0
                                                    } : {},
                                                    breakpoints: {
                                                        0: {
                                                            slidesPerView: a,
                                                            spaceBetween: parseInt(s)
                                                        },
                                                        768: {
                                                            slidesPerView: n,
                                                            spaceBetween: parseInt(i)
                                                        },
                                                        1024: {
                                                            slidesPerView: o,
                                                            spaceBetween: parseInt(r)
                                                        }
                                                    }
                                                };
                                            Object.assign(e, l), e.addEventListener("swiperafterinit", () => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.add("slider-enabled"), setTimeout(() => {
                                                    if (!e.swiper) return;
                                                    const t = e.swiper?.slides?.length || 0,
                                                        s = t < a ? t : a,
                                                        i = t < n ? t : n,
                                                        r = t < o ? t : o;
                                                    e.swiper && e.swiper.params && e.swiper.params.breakpoints && (e.swiper.currentBreakpoint = !1, e.swiper.params.breakpoints[0].slidesPerView = s, e.swiper.params.breakpoints[768].slidesPerView = i, e.swiper.params.breakpoints[992] && (e.swiper.params.breakpoints[992].slidesPerView = r), e.swiper.update(), e.swiper.slideTo(0, 0, !1)), d(), (() => {
                                                        const t = e.closest(".main-product__media-wrapper")?.querySelector(".swiper-thumbnails .swiper");
                                                        t && (Object.assign(t, {
                                                            direction: "vertical",
                                                            slidesPerView: "auto",
                                                            spaceBetween: 8,
                                                            watchSlidesProgress: !0,
                                                            navigation: {
                                                                nextEl: ".swiper-button-thumbs-next",
                                                                prevEl: ".swiper-button-thumbs-prev"
                                                            },
                                                            breakpoints: {
                                                                0: {
                                                                    direction: "horizontal",
                                                                    slidesPerView: 4
                                                                },
                                                                768: {
                                                                    direction: "vertical",
                                                                    slidesPerView: "auto"
                                                                }
                                                            }
                                                        }), t.initialize())
                                                    })()
                                                }, 0)
                                            }), e.addEventListener("swiperslidechange", () => {
                                                d(), c()
                                            }), e.addEventListener("swiperdestroy", () => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.remove("slider-enabled")
                                            }), e.addEventListener("swiperlock", () => {
                                                const t = e.closest(".shopify-section");
                                                t && !t.classList.contains("recommended-products") && setTimeout(() => {
                                                    t.querySelectorAll(".grid-content__slider-nav").forEach(e => {
                                                        e.style.display = "none"
                                                    })
                                                }, 1)
                                            }), e.initialize(), t && ((() => {
                                                if (!t) return;
                                                const s = e.closest(".slideshow-text-controls__wrapper");
                                                s && s.querySelectorAll(".slideshow-text-controls__item").forEach(t => {
                                                    t.addEventListener("click", () => {
                                                        const s = t.getAttribute("data-slide"),
                                                            i = Array.from(e.swiper.slides).findIndex(e => e.getAttribute("data-slide") === s); - 1 !== i && e.swiper.slideTo(i)
                                                    })
                                                })
                                            })(), c())
                                        } else e.swiper.update();
                                    else if (Object.assign(e), e.initialize(), e.swiper) {
                                        e.swiper.destroy(!0, !0);
                                        const t = e.closest(".shopify-section");
                                        t && t.classList.remove("slider-enabled")
                                    }
                                };
                            window.addEventListener("resize", p), p()
                        })
                    }
                }
            }
        },
        s = {};

    function i(e) {
        var r = s[e];
        if (void 0 !== r) return r.exports;
        var a = s[e] = {
            exports: {}
        };
        return t[e](a, a.exports, i), a.exports
    }
    i.m = t, e = [], i.O = function(t, s, r, a) {
            if (!s) {
                var n = 1 / 0;
                for (c = 0; c < e.length; c++) {
                    s = e[c][0], r = e[c][1], a = e[c][2];
                    for (var o = !0, l = 0; l < s.length; l++)(!1 & a || n >= a) && Object.keys(i.O).every(function(e) {
                        return i.O[e](s[l])
                    }) ? s.splice(l--, 1) : (o = !1, a < n && (n = a));
                    if (o) {
                        e.splice(c--, 1);
                        var d = r();
                        void 0 !== d && (t = d)
                    }
                }
                return t
            }
            a = a || 0;
            for (var c = e.length; c > 0 && e[c - 1][2] > a; c--) e[c] = e[c - 1];
            e[c] = [s, r, a]
        }, i.d = function(e, t) {
            for (var s in t) i.o(t, s) && !i.o(e, s) && Object.defineProperty(e, s, {
                enumerable: !0,
                get: t[s]
            })
        }, i.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, i.j = 1653,
        function() {
            var e = {
                1653: 0
            };
            i.O.j = function(t) {
                return 0 === e[t]
            };
            var t = function(t, s) {
                    var r, a, n = s[0],
                        o = s[1],
                        l = s[2],
                        d = 0;
                    if (n.some(function(t) {
                            return 0 !== e[t]
                        })) {
                        for (r in o) i.o(o, r) && (i.m[r] = o[r]);
                        if (l) var c = l(i)
                    }
                    for (t && t(s); d < n.length; d++) a = n[d], i.o(e, a) && e[a] && e[a][0](), e[a] = 0;
                    return i.O(c)
                },
                s = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
            s.forEach(t.bind(null, 0)), s.push = t.bind(null, s.push.bind(s))
        }();
    var r = i.O(void 0, [8096], function() {
        return i(9138)
    });
    r = i.O(r)
}();

